import { useNavigate } from "react-router-dom";
import { Colors } from "../../../utils/colors";
import StandardBorderedContainer from "../../Containers/StandardBorderedContainer";
import { Icon } from "@iconify/react";
import { NavigationId } from "../../../navigation/AppParamList";
import { useDispatch, useSelector } from "react-redux";
import { hasSubscription } from "@markit/common.utils";
import { PlanTypeV4 } from "@markit/common.types";
import { notificationActions } from "../../../redux/slices/notificationSlice";
import { AppState } from "../../../redux/store";

// If user has subscription, show referral banner. Otherwise, show get markit+ banner.
const CreatorModeSidebarBanners = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accountData = useSelector(
    (state: AppState) => state.account.accountData
  );

  return (
    <StandardBorderedContainer
      className="AlignedRow"
      containerStyles={{
        display: "flex",
        gap: 11,
        paddingInline: 12,
        paddingBlock: 8,
        marginInline: 10,
        marginBottom: 10,
        cursor: "pointer",
        border: "none",
      }}
      onPress={() =>
        hasSubscription(accountData)
          ? navigate(NavigationId.HOME_REFERRAL_PROGRAM)
          : dispatch(
              notificationActions.setMarkitPlusModal(PlanTypeV4.ESSENTIAL.name)
            )
      }
    >
      <div>
        <Icon
          icon={hasSubscription(accountData) ? "ion:gift" : "mdi:plus-box"}
          height={20}
          style={{
            color: hasSubscription(accountData) ? Colors.GREEN2 : Colors.BLUE5,
          }}
        />
      </div>
      <div className="ColumnNormal" style={{ gap: 3 }}>
        <span className="bodySmallMedium">
          {hasSubscription(accountData) ? "Refer a Friend" : "Get Markit+"}
        </span>
        <span className="smallBodySubtext" style={{ fontSize: 10 }}>
          {hasSubscription(accountData)
            ? "Earn up to $300 on eligible referrals"
            : "Get your own number when you upgrade"}
        </span>
      </div>
    </StandardBorderedContainer>
  );
};

export default CreatorModeSidebarBanners;
